import React, { useEffect, useState } from "react";
import AdminLayout from "./AdminLayout";

const AdminGalleryAlbum = () => {
  const [name, setName] = useState("");
  const [albums, setAlbums] = useState([]);
  const [images, setImages] = useState([]);
  const [openAlbum, setOpenAlbum] = useState(null);
  const [editId, setEditId] = useState(null);
  const [dragId, setDragId] = useState(null);

  /* FETCH */
  const fetchAlbums = () => {
    fetch(" https://node.ilakshyaerp.in/api/gallery/album")
      .then((res) => res.json())
      .then((res) => setAlbums(Array.isArray(res) ? res : []));
  };

  useEffect(() => {
    fetchAlbums();
  }, []);

  /* CREATE / UPDATE */
  const handleCreate = async () => {
    if (!name) return alert("Enter album name ❌");

    const url = editId
      ? ` https://node.ilakshyaerp.in/api/gallery/album/${editId}`
      : " https://node.ilakshyaerp.in/api/gallery/album";

    const method = editId ? "PUT" : "POST";

    const res = await fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ name }),
    });

    const data = await res.json();

    alert(data.message);

    setName("");
    setEditId(null);
    fetchAlbums();
  };

  /* EDIT */
  const handleEdit = (album) => {
    setName(album.name);
    setEditId(album.id);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  /* DELETE ALBUM */
  const handleDeleteAlbum = async (id) => {
    if (!window.confirm("Delete album?")) return;

    const res = await fetch(
      ` https://node.ilakshyaerp.in/api/gallery/album/${id}`,
      { method: "DELETE" }
    );

    const data = await res.json();

    alert(data.message);
    fetchAlbums();
  };

  /* COMMON UPLOAD */
  const uploadFiles = async (albumId, files) => {
    const formData = new FormData();

    for (let i = 0; i < files.length; i++) {
      formData.append("images", files[i]);
    }

    const res = await fetch(
      ` https://node.ilakshyaerp.in/api/gallery/upload/${albumId}`,
      {
        method: "POST",
        body: formData,
      }
    );

    const data = await res.json();

    alert(data.message);

    fetchAlbums();
    if (openAlbum?.id === albumId) loadAlbum(albumId);
  };

  /* NORMAL UPLOAD */
  const handleUpload = async (id) => {
    if (!images.length) {
      alert("Select images ❌");
      return;
    }

    uploadFiles(id, images);
  };

  /* OPEN ALBUM */
  const loadAlbum = async (id) => {
    const res = await fetch(
      ` https://node.ilakshyaerp.in/api/gallery/album/${id}`
    );

    const data = await res.json();

    setOpenAlbum({
      id,
      images: Array.isArray(data) ? data : [],
    });
  };

  /* DELETE IMAGE */
  const handleDeleteImage = async (id) => {
    const res = await fetch(
      ` https://node.ilakshyaerp.in/api/gallery/image/${id}`,
      { method: "DELETE" }
    );

    const data = await res.json();

    alert(data.message);
    loadAlbum(openAlbum.id);
  };

  /* SET COVER */
  const handleCover = async (image) => {
    const res = await fetch(
      ` https://node.ilakshyaerp.in/api/gallery/cover/${openAlbum.id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ image }),
      }
    );

    const data = await res.json();

    alert(data.message);
    fetchAlbums();
  };

  return (
    <AdminLayout>
      <div className="notice-page">

        {/* FORM */}
        <div className="notice-card">
          <h2>
            {editId ? "Edit Album" : "Create Album"}
          </h2>

          <input
            type="text"
            placeholder="Enter album name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />

          <button onClick={handleCreate}>
            {editId ? "Update Album" : "Create Album"}
          </button>
        </div>

        {/* TABLE */}
        <div className="notice-table">
          <h2>All Albums</h2>

          <table>
            <thead>
              <tr>
                <th>Cover</th>
                <th>Album Name</th>
                <th>Upload</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {albums.length === 0 ? (
                <tr>
                  <td colSpan="4">No Albums Found</td>
                </tr>
              ) : (
                albums.map((a) => (
                  <tr
                    key={a.id}
                    onDragOver={(e) => {
                      e.preventDefault();
                      setDragId(a.id);
                    }}
                    onDragLeave={() =>
                      setDragId(null)
                    }
                    onDrop={(e) => {
                      e.preventDefault();
                      setDragId(null);

                      const files =
                        e.dataTransfer.files;

                      if (!files.length) return;

                      const ok =
                        window.confirm(
                          `Upload ${files.length} file(s) into "${a.name}" album ?`
                        );

                      if (ok) {
                        uploadFiles(a.id, files);
                      }
                    }}
                    style={{
                      background:
                        dragId === a.id
                          ? "#eef4ff"
                          : "",
                      transition: "0.3s",
                    }}
                  >
                    <td>
                      <img
                        src={
                          a.coverImage
                            ? ` https://node.ilakshyaerp.in/uploads/gallery/${a.coverImage}`
                            : "https://via.placeholder.com/80"
                        }
                        alt=""
                        width="80"
                        style={{
                          borderRadius: "8px",
                        }}
                      />
                    </td>

                    <td>
                      <strong>{a.name}</strong>

                      <div
                        style={{
                          marginTop: "8px",
                          fontSize: "12px",
                          color:
                            dragId === a.id
                              ? "#1f3c6d"
                              : "#888",
                          border:
                            dragId === a.id
                              ? "2px dashed #1f3c6d"
                              : "2px dashed #ddd",
                          padding: "8px",
                          borderRadius: "8px",
                          background:
                            dragId === a.id
                              ? "#f4f8ff"
                              : "#fafafa",
                        }}
                      >
                        📁 Drag & Drop Images Here
                      </div>
                    </td>

                    <td>
                      <input
                        type="file"
                        multiple
                        onChange={(e) =>
                          setImages(
                            e.target.files
                          )
                        }
                      />

                      <button
                        className="upload-btn"
                        onClick={() =>
                          handleUpload(a.id)
                        }
                      >
                        Upload
                      </button>
                    </td>

                    <td>
                      <button
                        className="edit-btn"
                        onClick={() =>
                          handleEdit(a)
                        }
                      >
                        Edit
                      </button>

                      <button
                        className="delete-btn"
                        onClick={() =>
                          handleDeleteAlbum(
                            a.id
                          )
                        }
                      >
                        Delete
                      </button>

                      <button
                        className="open-btn"
                        onClick={() =>
                          loadAlbum(a.id)
                        }
                      >
                        Open
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* OPEN ALBUM */}
        {openAlbum && (
          <div className="notice-table">
            <h2>Album Images</h2>

            <table>
              <thead>
                <tr>
                  <th>Image</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {openAlbum.images.map(
                  (img) => (
                    <tr key={img.id}>
                      <td>
                        <img
                          src={` https://node.ilakshyaerp.in/uploads/gallery/${img.image}`}
                          alt=""
                          width="100"
                          style={{
                            borderRadius:
                              "8px",
                          }}
                        />
                      </td>

                      <td>
                        <button
                          className="edit-btn"
                          onClick={() =>
                            handleCover(
                              img.image
                            )
                          }
                        >
                          Set Cover
                        </button>

                        <button
                          className="delete-btn"
                          onClick={() =>
                            handleDeleteImage(
                              img.id
                            )
                          }
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            </table>
          </div>
        )}

      </div>
    </AdminLayout>
  );
};

export default AdminGalleryAlbum;